export default __webpack_public_path__ + "static/media/quad.4cb1b784.png";